import styles from "./footer.module.css";

const Footer = ({ companyName = "Company" }) => {
  const year = new Date().getFullYear();

  return (<div className={`${styles.FooterFluid}`}>
    <div className={`${styles.FooterContainer} ${styles.Container}`}>
      <div className={`${styles.Container}`}>
        <p className={`${styles.CopyText}`}>©{year} {companyName}, All Right Reserved</p>
      </div>
    </div>
  </div>);
}

export default Footer;